'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'envelope-dot';
var width = 576;
var height = 512;
var aliases = ["envelope-badge"];
var unicode = 'e16f';
var svgPathData = ['M16 128c0-26.5 21.5-48 48-48l353.3 0c6.6 39.4 37.1 70.6 76.1 78.2L291.2 321.4c-20.5 16.5-49.8 16.5-70.3 0L16 156.2 16 128zm0 48.7L210.8 333.8c26.4 21.3 64 21.3 90.4 0L496 176.7 496 384c0 26.5-21.5 48-48 48L64 432c-26.5 0-48-21.5-48-48l0-207.3z', 'M464 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 448 64a64 64 0 1 0 128 0zM512 384l0-224c-6.3 0-12.5-.6-18.5-1.8L291.2 321.4c-20.5 16.5-49.8 16.5-70.3 0L16 156.2 16 128c0-26.5 21.5-48 48-48l353.3 0c-.9-5.2-1.3-10.5-1.3-16L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM16 176.7L210.8 333.8c26.4 21.3 64 21.3 90.4 0L496 176.7 496 384c0 26.5-21.5 48-48 48L64 432c-26.5 0-48-21.5-48-48l0-207.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEnvelopeDot = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;